export default class CalculatorResults {
  constructor({ ...props }) {
    this._id = props._id;
    this.selectedCropId = props.selectedCropId;
    this.selectedFertilizerId = props.selectedFertilizerId;
    this.selectedPrice = props.selectedPrice;
    this.costOfMicroessentials = this.round(props.costOfMicroessentials);
    this.currentBlendAmmoniumSulfateSo4Amount = this.round(props.currentBlendAmmoniumSulfateSo4Amount);
    this.currentBlendAmountOfZinc = this.round(props.currentBlendAmountOfZinc);
    this.currentBlendCostOfBlend = this.round(props.currentBlendCostOfBlend);
    this.currentBlendElementalSulfurAmount = this.round(props.currentBlendElementalSulfurAmount);
    this.currentBlendTotalNitrogen = this.round(props.currentBlendTotalNitrogen);
    this.currentNitrogenInNutrientSummary = this.round(props.currentNitrogenInNutrientSummary);
    this.currentSO4InNutrientSummary = this.round(props.currentSO4InNutrientSummary);
    this.form = props.form;
    this.formula = props.formula;
    this.formulaImageUrl = props.formulaImageUrl ? 'https:' + props.formulaImageUrl : null;
    this.roiIncrease = this.currency(props.roiIncrease);
    this.yieldAdvantage = props.yieldAdvantage;
    this.crop = props.crop;
    this.cropPrice = this.currency(props.cropPrice);
    this.currentBlend = props.currentBlend;
    this.microessentialsElementalSulfur = this.round(props.microessentialsElementalSulfur);
    this.microessentialsNitrogen = this.round(props.microessentialsNitrogen);
    this.microessentialsSulfateSulfur = this.round(props.microessentialsSulfateSulfur);
    this.microessentialsZinc = this.round(props.microessentialsZinc);
    this.phosphorusRate = this.round(props.phosphorusRate);
    this.rateOfPhosphorusApplied = props.rateOfPhosphorusApplied;
    this.sulfurBlend = props.sulfurBlend;
    this.zincBlend = props.zincBlend;
    this.zincRate = props.zincRate;
  }

  currency(value) {
    return `$${Number(value).toFixed(2)}`;
  }

  round(value) {
    return Number(value).toFixed(2);
  }
}
